!(function (e) {
    var t = {};
    function s(i) {
        if (t[i]) return t[i].exports;
        var r = (t[i] = { i: i, l: !1, exports: {} });
        return e[i].call(r.exports, r, r.exports, s), (r.l = !0), r.exports;
    }
    (s.m = e),
        (s.c = t),
        (s.d = function (e, t, i) {
            s.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: i });
        }),
        (s.r = function (e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e, "__esModule", { value: !0 });
        }),
        (s.t = function (e, t) {
            if ((1 & t && (e = s(e)), 8 & t)) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var i = Object.create(null);
            if ((s.r(i), Object.defineProperty(i, "default", { enumerable: !0, value: e }), 2 & t && "string" != typeof e))
                for (var r in e)
                    s.d(
                        i,
                        r,
                        function (t) {
                            return e[t];
                        }.bind(null, r)
                    );
            return i;
        }),
        (s.n = function (e) {
            var t =
                e && e.__esModule
                    ? function () {
                          return e.default;
                      }
                    : function () {
                          return e;
                      };
            return s.d(t, "a", t), t;
        }),
        (s.o = function (e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }),
        (s.p = ""),
        s((s.s = 29));
})({
    0: function (e, t, s) {
        "use strict";
        s.d(t, "g", function () {
            return r;
        }),
            s.d(t, "k", function () {
                return n;
            }),
            s.d(t, "j", function () {
                return a;
            }),
            s.d(t, "b", function () {
                return o;
            }),
            s.d(t, "l", function () {
                return c;
            }),
            s.d(t, "a", function () {
                return l;
            }),
            s.d(t, "d", function () {
                return u;
            }),
            s.d(t, "h", function () {
                return h;
            }),
            s.d(t, "f", function () {
                return d;
            }),
            s.d(t, "c", function () {
                return p;
            }),
            s.d(t, "e", function () {
                return m;
            }),
            s.d(t, "i", function () {
                return g;
            });
        var i = document.querySelector("[data-site-container]");
        function r() {
            (i.style.overflowY = "hidden"), (i.style.height = "100dvh");
        }
        function n() {
            i.style.removeProperty("overflow"), (i.style.height = "auto");
        }
        function a(e, t, s) {
            let i = "";
            if (s && "" !== s) {
                let e = new Date();
                e.setTime(e.getTime() + 24 * s * 60 * 60 * 1e3), (i = "; expires=" + e.toUTCString());
            } else i = '; expires=""';
            document.cookie = `${e}=${t}${i}; path=/`;
        }
        function o(e) {
            let t = e + "=",
                s = document.cookie.split(";");
            for (let e = 0; e < s.length; e++) {
                let i = s[e];
                for (; " " == i.charAt(0); ) i = i.substring(1);
                if (-1 != i.indexOf(t)) return i.substring(t.length, i.length);
            }
            return null;
        }
        function c(e) {
            const t = e.includes("&") ? e.split("&")[0] : e,
                s = document.querySelector('[type="application/ld+json"]'),
                i = s.innerHTML;
            let [r, n] = i.split('"@id": "');
            (n = n.split(n.split('"')[0])[1]), console.log(`${r}"@id": "${t}${n}`), (s.innerHTML = `${r}"@id": "${t}${n}`), (document.querySelector('[rel="canonical"]').href = theme.url + t);
        }
        const l = (e, t) => {
            let s;
            return function (...i) {
                s && clearTimeout(s),
                    (s = setTimeout(() => {
                        e(...i);
                    }, t));
            };
        };
        async function u(e) {
            const t = await fetch(e, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
            return await t.json();
        }
        async function h(e, t, s = {}) {
            const i = await fetch(e, { method: "POST", headers: { "Content-Type": "application/json", ...s }, body: JSON.stringify(t) });
            if (!i.ok) throw new Error("HTTP error! Status: " + i.status);
            return await i.json();
        }
        async function d(e) {
            const t = e.handle ? "/products/" + e.handle : e.mappings.core.url,
                s = e.params && e.params.lazyload ? "" : "&lazyload=false",
                i = e.params && e.params.isSlide ? "&slide=true" : "",
                r = e.params && "false" == e.params.showWishlist ? "&wishlist=false" : "",
                n = e.params && "false" == e.params.showStrips ? "&featureStrips=false" : "",
                a = e.params && "false" == e.params.showReviews ? "&reviews=false" : "",
                o = e.params && "false" == e.params.showRoundels ? "&roundels=false" : "",
                c = e.params && "true" == e.params.altImage ? "&alternatePicture=true" : "",
                l = e.params && void 0 !== e.params.index ? "&index=" + e.params.index : "",
                u = `${t}?sections=product-list-item${s}${i}${a}${o}${c}${r}${n}${e.intellisuggestData ? "&intellisuggestData=" + e.intellisuggestData : ""}${
                    e.intellisuggestSignature ? "&intellisuggestSignature=" + e.intellisuggestSignature : ""
                }${l}`;
            return await fetch(u, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
        }
        async function p(e, t) {
            const s = e.handle ? "/products/" + e.handle : e.mappings.core.url,
                i = await (async function (e) {
                    try {
                        let t = await fetch(e);
                        if (!t.ok) throw new Error(`HTTP error for endpoint ${e} - Status: ${t.status}`);
                        return await t.json();
                    } catch (e) {
                        return console.error("Error fetching data:", e), {};
                    }
                })(s + "?view=gaData");
            return (function (e, t = {}, s) {
                const i = e.mappings ? { id: e.id, ...e.mappings.core } : e,
                    r = { index: s, discount: i.msrp - i.price, item_brand: i.brand, price: i.price, quantity: 1 };
                return (
                    i.product_type_unigram && (r.item_variant = i.product_type_unigram),
                    t.item_id || (r.item_id = i.id),
                    t.item_name || (r.item_name = i.name),
                    e.mappings ? (r.item_category4 = "Rec: " + e.params.placementTag) : theme.relativeItemCategory && (r.item_category4 = theme.relativeItemCategory),
                    { ...r, ...t }
                );
            })(e, (await i).product, t);
        }
        async function m(e) {
            const t = `/products/${e.handle}?sections=product-list-item&lazyload=false`;
            return await fetch(t, { method: "get", headers: { Accept: "application/json, text/plain, */*", "Content-Type": "application/json" } });
        }
        function g(e, t, s = theme.collectionName, i = theme.collectionTitle) {
            console.log(t), console.log({ item_list_id: s || "", item_list_name: i || theme.relativeItemCategory, items: e });
        }
    },
    29: function (e, t, s) {
        e.exports = s(30);
    },
    30: function (e, t, s) {
        "use strict";
        s.r(t);
        var i = s(0);
        class r extends HTMLElement {
            constructor() {
                super(),
                    (this.input = this.querySelector('input[type="search"]')),
                    (this.resetButton = this.querySelector('button[type="reset"]')),
                    (this.searchCloseWrapper = document.querySelector("[data-close-search-modal]")),
                    (this.overlay = document.querySelector("[data-search-overlay]")),
                    (this.wrapper = document.querySelector("[data-predictive-search-wrapper]")),
                    (this.searchspringEndpoints = {
                        root: `https://${theme.siteId}.a.searchspring.io/api/`,
                        search: "search/search.json?siteId=" + theme.siteId,
                        suggest: "suggest/query?siteId=" + theme.siteId,
                        autocomplete: "search/autocomplete.json?siteId=" + theme.siteId,
                        trending: `suggest/trending?siteId=${theme.siteId}&limit=6`,
                    }),
                    (this.classes = { hidden: "hidden", visible: "is-visible", open: "is-open", loadingSpinner: "loading-spinner", loading: "is-loading" }),
                    this.input &&
                        (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                        this.input.addEventListener(
                            "input",
                            Object(i.a)((e) => {
                                this.onChange(e);
                            }, 300).bind(this)
                        ));
            }
            toggleResetButton() {
                const e = this.resetButton.classList.contains(this.classes.hidden);
                this.input.value.length > 0 && e ? this.resetButton.classList.remove(this.classes.hidden) : 0 !== this.input.value.length || e || this.resetButton.classList.add(this.classes.hidden);
            }
            onChange() {
                this.toggleResetButton();
            }
            shouldResetForm() {
                return !document.querySelector('[aria-selected="true"] a');
            }
            onFormReset(e) {
                e.preventDefault(), this.shouldResetForm() && ((this.input.value = ""), this.input.focus(), this.toggleResetButton(), this.loadSuggestedResults());
            }
        }
        customElements.define("search-form", r),
            customElements.define(
                "predictive-search",
                class extends r {
                    constructor() {
                        super(),
                            (this.cachedResults = {}),
                            (this.predictiveContainer = document.querySelector("[data-predictive-container]")),
                            (this.predictiveSearchResults = document.querySelector("[data-predictive-search]")),
                            (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
                            (this.isOpen = !1),
                            (this.abortController = new AbortController()),
                            (this.searchTerm = ""),
                            this.setupEventListeners();
                    }
                    setupEventListeners() {
                        this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                            this.input.addEventListener("focus", this.onFocus.bind(this)),
                            this.addEventListener("focusout", this.onFocusOut.bind(this)),
                            this.predictiveContainer.addEventListener("focusout", this.onFocusOut.bind(this)),
                            this.addEventListener("keyup", this.onKeyup.bind(this)),
                            this.addEventListener("keydown", this.onKeydown.bind(this)),
                            this.searchCloseWrapper && this.searchCloseWrapper.addEventListener("click", this.closeModal.bind(this)),
                            this.loadSuggestedResults();
                    }
                    loadSuggestedResults() {
                        if ("true" === theme.search.suggested_content_enabled) {
                            const e = this.getSearchResults.bind(this),
                                t = this.open.bind(this);
                            async function s(s) {
                                await e(null), s.target.value.length > 0 && e(s.target.value), t();
                            }
                            this.input.addEventListener("click", s),
                                this.input.addEventListener(
                                    "change",
                                    function e(t) {
                                        this.input.removeEventListener("click", s), this.input.removeEventListener("change", e.bind(this));
                                    }.bind(this)
                                );
                        }
                    }
                    getQuery() {
                        return (theme.relativeItemCategory = "Autocomplete: " + this.input.value.trim()), this.input.value.trim();
                    }
                    onClickSearchClose() {
                        this.wrapper.classList.remove(this.classes.visible);
                    }
                    onChange() {
                        super.onChange();
                        const e = this.getQuery();
                        !this.searchTerm || e.startsWith(this.searchTerm), this.updateSearchForTerm(this.searchTerm, e), (this.searchTerm = e), this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.close(!0);
                    }
                    onFormSubmit(e) {
                        (this.getQuery().length && !this.querySelector('[aria-selected="true"] a')) || e.preventDefault();
                    }
                    onFormReset(e) {
                        super.onFormReset(e), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
                    }
                    onFocus() {
                        const e = this.getQuery();
                        (e.length || 0 !== this.searchTerm.length) && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? this.open() : this.getSearchResults(this.searchTerm));
                    }
                    onFocusOut() {
                        setTimeout(() => {
                            this.contains(document.activeElement) || this.predictiveContainer.contains(document.activeElement) || this.classList.contains(this.classes.open) || this.close();
                        });
                    }
                    onKeyup(e) {
                        switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
                            case "ArrowUp":
                                this.switchOption("up");
                                break;
                            case "ArrowDown":
                                this.switchOption("down");
                                break;
                            case "Enter":
                                this.selectOption();
                        }
                    }
                    onKeydown(e) {
                        ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
                    }
                    updateSearchForTerm(e, t) {
                        let s = 0;
                        const i = setInterval(() => {
                            s > 20 && clearInterval(i);
                            const e = document.querySelector("[data-predictive-search-search-for-text]");
                            if (e) {
                                clearInterval(i);
                                const s = e.querySelector("[data-autocomplete-search-term]");
                                s && (s.innerText = t), e.parentNode.setAttribute("href", `${theme.shopUrl}/search?q=${t}`);
                            } else s += 1;
                        }, 200);
                    }
                    switchOption(e) {
                        if (!this.getAttribute("open")) return;
                        const t = "up" === e,
                            s = this.querySelector('[aria-selected="true"]'),
                            i = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter((e) => null !== e.offsetParent);
                        let r = 0;
                        if (t && !s) return;
                        let n = -1,
                            a = 0;
                        for (; -1 === n && a <= i.length; ) i[a] === s && (n = a), a++;
                        if (((this.statusElement.textContent = ""), !t && s ? (r = n === i.length - 1 ? 0 : n + 1) : t && (r = 0 === n ? i.length - 1 : n - 1), r === n)) return;
                        const o = i[r];
                        o.setAttribute("aria-selected", !0), s && s.setAttribute("aria-selected", !1), this.input.setAttribute("aria-activedescendant", o.id);
                    }
                    selectOption() {
                        const e = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
                        e && e.click();
                    }
                    async getSearchspringSearchApiResults(e, t) {
                        const s = `&q=${e}${"search" === t || "autocomplete" === t ? "&resultsFormat=json" : ""}`,
                            r = `${this.searchspringEndpoints.root}${this.searchspringEndpoints[t]}${s}${"autocomplete" === t ? "&resultsPerPage=1000" : ""}`;
                        return await Object(i.d)(r);
                    }
                    async getSearchResults(e) {
                        if (null !== e) {
                            this.setLiveRegionLoadingState();
                            const t = document.querySelector("[data-suggestions-col]"),
                                s = document.querySelector("[data-results-col]"),
                                r = await this.getSearchspringSearchApiResults(e, "suggest"),
                                n = t.querySelector("ul");
                            n.innerHTML = "";
                            const a = e.toLowerCase(),
                                o = [...(e.length > 2 ? theme.search.suggested_searches.filter((e) => e.toLowerCase().startsWith(a)) : []), ...r.alternatives, { ...r.suggested }];
                            let c = [];
                            const l = document.createElement("ul");
                            o.forEach((e, t) => {
                                if (10 === c.length) return;
                                const s = document.createElement("li"),
                                    i = document.createElement("a"),
                                    r = e.completed,
                                    n = e.text;
                                let o = null;
                                if ((r && r[0] ? (o = r[0].token) : n ? (o = n) : "string" == typeof e && (o = e.toLowerCase()), !o || c.includes(o))) return;
                                c.push(o);
                                const u = o.replace(a, `<span class="highlighted">${a}</span>`);
                                (i.href = `${theme.shopUrl}/search?q=${o}`), (i.innerHTML = u), s.appendChild(i), l.appendChild(s);
                            }),
                                (n.innerHTML = l.innerHTML),
                                t.hasAttribute("hidden") && t.removeAttribute("hidden");
                            const u = await this.getSearchspringSearchApiResults(e, "autocomplete"),
                                h = s.querySelector("ul"),
                                d = u.results ? await u.results.slice(0, 4).map(i.e) : [],
                                p = u.results ? await u.results.slice(0, 4).map(i.c) : [],
                                m = await Promise.all(p);
                            (this.gaItems = m),
                                Object(i.i)(this.gaItems, "view_item_list", "Autocomplete: " + this.searchTerm),
                                Promise.all(d).then((e) => {
                                    const t = e.map((e) => e.json());
                                    Promise.all(t).then((e) => {
                                        const t = e.map((e) => e["product-list-item"]).join("");
                                        (h.innerHTML = t), theme.wishlistModal(), this.addItemClickListeners(h);
                                    });
                                });
                            const g = document.querySelector("[data-results-title]");
                            if (g) {
                                g.removeAttribute("hidden");
                                const t = document.querySelector("[data-autocomplete-count]");
                                t && (t.innerText = 500 === u.results.length ? u.results.length + "+" : u.results.length);
                                const s = document.querySelector("[data-autocomplete-search-term]");
                                s && (s.innerHTML = `<span class="highlighted">"${e}"</span>`);
                            }
                            s.hasAttribute("hidden") && s.removeAttribute("hidden");
                        } else {
                            if ((this.setLiveRegionLoadingState(), this.cachedResults["predictive-search-default-suggestions"])) return void this.renderSearchResults(this.cachedResults["predictive-search-default-suggestions"]);
                            fetch(routes.root_url + "?section_id=searchspring-predictive-search", { signal: this.abortController.signal })
                                .then(async (e) => {
                                    if (!e.ok) {
                                        const s = await e.text();
                                        var t = new Error(e.status + " " + s);
                                        throw (this.close(), t);
                                    }
                                    return e.text();
                                })
                                .then(async (t) => {
                                    const s = new DOMParser().parseFromString(t, "text/html").querySelector("#shopify-section-searchspring-predictive-search").innerHTML;
                                    if (
                                        (this.renderSearchResults(s),
                                        this.allPredictiveSearchInstances.forEach((e) => {
                                            e.cachedResults["predictive-search-default-suggestions"] = s;
                                        }),
                                        theme.search.searchspring_trending_enabled)
                                    ) {
                                        const t = document.querySelector("[data-suggestions-col]"),
                                            s = await this.getSearchspringSearchApiResults(e, "trending");
                                        if (s.trending && s.trending.queries) {
                                            const e = s.trending.queries,
                                                i = t.querySelector("ul");
                                            i.innerHTML = "";
                                            const r = document.createElement("ul");
                                            e.forEach((e) => {
                                                const t = document.createElement("li"),
                                                    s = document.createElement("a"),
                                                    i = e.searchQuery;
                                                (s.href = `${theme.shopUrl}/search?q=${i}`), (s.innerText = i), t.appendChild(s), r.appendChild(t);
                                            }),
                                                (i.innerHTML = r.innerHTML),
                                                t.hasAttribute("hidden") && t.removeAttribute("hidden");
                                        }
                                    }
                                })
                                .catch((e) => {
                                    if (!e || 20 !== e.code) throw (this.close(), e);
                                });
                        }
                        this.modalInterval = setInterval(this.checkForCloseButton.bind(this), 300);
                    }
                    addItemClickListeners(e) {
                        async function t(e) {
                            if (!0 === this.clickLogged) return;
                            e.preventDefault();
                            const t = e.target.classList.contains("product-list-item") ? e.target : e.target.closest(".product-list-item");
                            if (this.gaItems) {
                                const e = this.gaItems.find((e) => String(e.item_id) === t.getAttribute("data-product-sku"));
                                e && Object(i.i)([e], "select_item", this.searchTerm, "Autocomplete: " + this.searchTerm);
                            }
                            (this.clickLogged = !0), e.target.click();
                        }
                        e.querySelectorAll(".product-list-item").forEach((e) => {
                            e.addEventListener("click", t.bind(this));
                        });
                    }
                    checkForCloseButton() {
                        const e = document.querySelector("[data-close-search-modal]");
                        e && (e.addEventListener("click", this.closeModal.bind(this)), clearInterval(this.modalInterval));
                    }
                    setLiveRegionLoadingState() {
                        (this.statusElement = this.statusElement || document.querySelector(".predictive-search-status")),
                            (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                            this.setLiveRegionText(this.loadingText),
                            this.setAttribute("loading", !0),
                            this.predictiveContainer.setAttribute("loading", !0);
                    }
                    setLiveRegionText(e) {
                        this.statusElement.setAttribute("aria-hidden", "false"),
                            (this.statusElement.textContent = e),
                            setTimeout(() => {
                                this.statusElement.setAttribute("aria-hidden", "true");
                            }, 1e3);
                    }
                    renderSearchResults(e) {
                        (this.predictiveSearchResults.innerHTML = e), this.setAttribute("results", !0), this.predictiveContainer.setAttribute("results", !0), this.setLiveRegionResults(), this.open();
                    }
                    setLiveRegionResults() {
                        this.removeAttribute("loading"), this.predictiveContainer.removeAttribute("loading");
                        const e = document.querySelector("[data-predictive-search-live-region-count-value]");
                        e && e.textContent && this.setLiveRegionText(e.textContent);
                    }
                    getResultsMaxHeight() {
                        return (this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom), this.resultsMaxHeight;
                    }
                    open() {
                        this.overlay.classList.add(this.classes.visible),
                            (this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px"),
                            this.setAttribute("open", !0),
                            this.predictiveContainer.setAttribute("open", !0),
                            this.input.setAttribute("aria-expanded", !0),
                            (this.isOpen = !0),
                            this.checkForCloseButton();
                    }
                    close(e = !1) {
                        this.closeResults(e), (this.isOpen = !1);
                    }
                    closeModal() {
                        this.closeResults(!1), (this.isOpen = !1), this.overlay.classList.remove("is-visible"), document.activeElement.blur();
                    }
                    closeResults(e = !1) {
                        e && ((this.input.value = ""), this.removeAttribute("results"), this.predictiveContainer.removeAttribute("results"));
                        const t = this.querySelector('[aria-selected="true"]');
                        t && t.setAttribute("aria-selected", !1),
                            this.input.setAttribute("aria-activedescendant", ""),
                            this.removeAttribute("loading"),
                            this.predictiveContainer.removeAttribute("loading"),
                            this.removeAttribute("open"),
                            this.predictiveContainer.removeAttribute("open"),
                            this.input.setAttribute("aria-expanded", !1),
                            (this.resultsMaxHeight = !1),
                            this.predictiveContainer.removeAttribute("style"),
                            this.overlay.classList.remove(this.classes.visible);
                    }
                }
            );
    },
});
